import React, { FunctionComponent } from 'react';
import isAndroid from '../../utils/isAndroid';
import { withTrack, WithTrack } from '../../utils/analytics';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';
import { usePageMeta } from '../../hooks';
import { LinkButton } from './LinkButton';
import { ShareLabel } from './ShareLabel';

export type SMSShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const SMSShare: FunctionComponent<SMSShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();
  const { isPreview } = usePageMeta();

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'sms',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
    if (isAndroid(window)) {
      navigator.clipboard.writeText(shareItems.sms.message);
    }
  };

  const as = !isPreview ? 'a' : 'div';
  const href = !isPreview ? `sms:?&body=${shareItems.sms.message}` : undefined;
  const handleClick = !isPreview ? trackClick : undefined;
  return (
    <LinkButton
      as={as}
      dataQa="sms-btn"
      href={href}
      onClick={handleClick}
      className={`jg-btn jg-btn--sms ${className}`}
    >
      <ShareLabel labelText={t('common.sms')} />
    </LinkButton>
  );
};

export default withTrack(SMSShare);
